import cn from 'clsx';
import { FC, useContext } from 'react';

import { IconType } from '../../../types';
import Icon from '../../Icon';
import AccordionContext from '../context';

import s from './AccordionIcon.module.scss';

export interface AccordionIconProps {
  size?: number;
  type?: IconType;
}

const AccordionIcon: FC<React.PropsWithChildren<React.PropsWithChildren<AccordionIconProps>>> = ({ type = 'expand-more', size = 18 }) => {
  const AccordionIconContext = useContext(AccordionContext);

  return (
    <Icon
      className={cn(
        {
          [s.close as string]: AccordionIconContext && AccordionIconContext.isExpanded
        },
        s.transition,
        s.icon
      )}
      type={type}
      size={size}
    />
  );
};

export default AccordionIcon;
